// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/index.scss
// module id = 766
// module chunks = 0 1